"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const TabManagerWeb = (props) => {
    const { setTab, tabs, activeTab } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: "tab-manager", children: tabs.map((tab, index) => ((0, jsx_runtime_1.jsxs)("div", { className: `tab ${tab.name === activeTab ? 'active' : ''}`, onClick: () => setTab(tab.name), children: [tab.icon && (0, jsx_runtime_1.jsx)("img", { alt: "", src: tab.name === activeTab ? tab.iconActive : tab.icon }), tab.label] }, `Tab${index}`))) }));
};
exports.default = TabManagerWeb;
